import { jsx as i } from "react/jsx-runtime";
import { forwardRef as l } from "react";
import { P as n } from "./Pill-uAcQLotY.js";
const f = {
  cold: "info",
  warm: "warning",
  hot: "error"
}, p = l(
  function({ temperature: r, variant: e = "soft", size: o = "sm", children: a, ...t }, m) {
    return /* @__PURE__ */ i(
      n,
      {
        ref: m,
        tone: f[r],
        variant: e,
        size: o,
        "data-temperature": r,
        ...t,
        children: a
      }
    );
  }
);
p.displayName = "LeadTemperaturePill";
export {
  p as L
};
//# sourceMappingURL=LeadTemperaturePill-CV3tceK8.js.map
